/* mot = Manufacturing Order Type */
import { merge } from 'ramda';
import {
  SUCCESS, OPTIONS_SUCCESS, REQUEST, FAIL
} from 'src/store/actions/motActions';

const initialState = {
  list: [],
  fetching: false,
  errors: [],
  options: []
};

const mot = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return merge(state, { fetching: true });
    case SUCCESS:
      return merge(state, { list: action.mot, fetching: false, errors: [] });
    case OPTIONS_SUCCESS:
      return merge(state, { options: action.motOptions, fetching: false, errors: [] });
    case FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    default:
      return state;
  }
};

export default mot;
